<div class="p-support-info">
  <div class="p-support-info__head">
    <h2 class="p-support-info__head-title" [innerHTML]="'label.wheelchairType' | staticMsg"></h2>
  </div>
  <div class="p-support-info__body">
    <div class="p-support-info__item">
      <div class="p-support-info__row">
        <fieldset class="p-support-info__radio" role="radiogroup" aria-invalid="false">
          <legend class="p-support-info__radio-legend" [innerHTML]="'label.wheelchairType' | staticMsg"></legend>
          <div class="p-support-info__radio-list">
            <div *ngFor="let item of wheelchairTypeSelectList; index as idx" class="p-support-info__radio-item">
              <!-- [14.20] 車いす種類-->
              <input
                type="radio"
                name="radio1"
                id="radio1_{{ idx + 1 }}"
                class="p-support-info__radio-item-input"
                (change)="typeChange(item.value)"
                [checked]="type === item.value"
              />
              <label for="radio1_{{ idx + 1 }}" class="p-support-info__radio-item-label">
                <span class="p-support-info__radio-item-check"></span>
                <span class="p-support-info__radio-item-text-wrap">
                  <span class="p-support-info__radio-item-text" [innerHTML]="item.label | staticMsg"></span>
                </span>
              </label>
            </div>
            <asw-validation-error
              *ngIf="selectError"
              id="{{ id }}_radio-error"
              [errorMessage]="selectError"
            ></asw-validation-error>
          </div>
        </fieldset>
      </div>
    </div>
    <!-- [14.21] バッテリータイプ-->
    <div class="p-support-info__item">
      <div class="p-support-info__row">
        <asw-select
          required
          [formControl]="batteryTypeFc"
          [label]="'label.batteryType' | staticMsg"
          [disabled]="type !== WHEEL_CHAIR_BATTERY_CODE"
        >
          <option *ngFor="let item of master" [value]="item.value" [innerHTML]="item.display_content"></option>
        </asw-select>
      </div>
    </div>
    <!-- [14.23] サポート情報追加 -->
    <div class="p-support-info__row">
      <p class="p-booking-info-mdl__describe">
        {{ 'About battery type' }}
        <asw-tooltip
          iconImage="<img src=&quot;assets/images/icon_help_primary_20.svg&quot; alt={{
            'm_static_message-alt.helpIcon2' | staticMsg
          }} width=&quot;20&quot; height=&quot;20&quot;>"
          [tooltipContent]="'tooltip.batteryType' | staticMsg"
          [displayAreaClass]="'p-support-info'"
        >
        </asw-tooltip>
      </p>
    </div>
  </div>
</div>
